// extracted by mini-css-extract-plugin
module.exports = {"largeMargin":"DividerSlice_largeMargin__2a4aa","mediumMargin":"DividerSlice_mediumMargin__3aa99","smallMargin":"DividerSlice_smallMargin__f56a7"};